import { render, staticRenderFns } from "./form_salary_detail.vue?vue&type=template&id=1902d1c0&scoped=true"
import script from "./form_salary_detail.vue?vue&type=script&lang=js"
export * from "./form_salary_detail.vue?vue&type=script&lang=js"
import style0 from "./form_salary_detail.vue?vue&type=style&index=0&id=1902d1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902d1c0",
  null
  
)

export default component.exports